import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { find, has } from 'lodash';
import {
  activateSource,
  pauseSource,
  runSource,
  deleteSource,
  copySource,
  setPipelineAction,
} from 'js/actions';
import {
  ACTIVATE_SOURCE,
  PAUSE_SOURCE,
  COPY_SOURCE,
  DELETE_SOURCE,
} from 'js/constants/processTypes';
import { isSqlAutomation } from 'js/lib/ResourceUtils';

import DataSourceDetailActions from './DataSourceDetailActions';
import withChangeIngestion from 'new/elements/ChangeIngestionMode/withChangeIngestion';
import compose from 'new/utils/compose';
import { withResourceEditProvider } from 'js/components/ResourceEditProvider/withResourceEditProvider';
import { useResourceDetailHandler } from 'new/components/ResourceDetailHandler/context';

const mapStateToProps = (state, ownProps) => {
  const {
    paging: { metaInfoById },
    entities: { flowNodes, vendors },
    processes: { all: processes },
    pipelines: { branches },
  } = state;
  const { data, connectionOrVendorType } = ownProps;
  const { id } = data;

  const isPausing = !!find(processes, { type: PAUSE_SOURCE, id });
  const isActivating = !!find(processes, { type: ACTIVATE_SOURCE, id });
  const isCopying = !!find(processes, { type: COPY_SOURCE, id });
  const isDeleting = !!find(processes, { type: DELETE_SOURCE, id });

  const behaviorType = isSqlAutomation(data, vendors ?? {}) ? 'sql_runner' : connectionOrVendorType;
  const connectionCategory =
    metaInfoById && has(metaInfoById, behaviorType)
      ? metaInfoById[behaviorType].connectionCategory
      : null;

  const flow = flowNodes[data.origin_node_id];
  const hasDestination = ownProps.inPipeline
    ? (branches[data.origin_node_id]?.items || []).some((k) => flowNodes[k]?.type === 'DATA_SINK')
    : true;

  return {
    flow,
    isPausing,
    isActivating,
    isCopying,
    isDeleting,
    connectionCategory,
    isSqlAutomation: isSqlAutomation(data, vendors ?? {}),
    hasDestination,
  };
};

function DataSourceDetailActionsWithContext(props) {
  const { openDetailDrawerInPortal } = useResourceDetailHandler();
  return <DataSourceDetailActions {...props} openDetailDrawerInPortal={openDetailDrawerInPortal} />;
}

export default compose(
  connect(mapStateToProps, {
    activateSource,
    pauseSource,
    runSource,
    deleteSource,
    copySource,
    setPipelineAction,
  }),
  withResourceEditProvider,
  withChangeIngestion({ resourceType: 'source' }),
  withRouter,
)(DataSourceDetailActionsWithContext);
